import { render, staticRenderFns } from "./TheHomeWeddings.vue?vue&type=template&id=49ce8c6e&scoped=true"
import script from "./TheHomeWeddings.vue?vue&type=script&lang=js"
export * from "./TheHomeWeddings.vue?vue&type=script&lang=js"
import style0 from "./TheHomeWeddings.vue?vue&type=style&index=0&id=49ce8c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce8c6e",
  null
  
)

export default component.exports